import * as React from 'react';
import { ICADefForm, IBaseComponentProps, ICAForm, IOrgConfig } from '../../types';
import SignOffForm from './SignOffForm';
import CancelSignOffForm from './CancelSignOffForm';

export interface ISignOffListProps extends IBaseComponentProps {
    defForm: ICADefForm;
    formId: number;
    form: ICAForm;
    onSignOff: () => void;
    canSignOffDDSection: boolean;
    canSignOffDirSection: boolean;
    showCancelSignOffs: boolean;
    orbConfig: IOrgConfig;
}

export interface ISignOffListState {
    Loading: boolean;
}

export default class SignOffList extends React.Component<ISignOffListProps, ISignOffListState> {

    constructor(props: ISignOffListProps) {
        super(props);
    }

    public render(): React.ReactElement<ISignOffListProps> {
        const { defForm, showCancelSignOffs } = this.props;
        return (
            <div>
                <div style={{ position: 'relative' }}>
                    {this.renderDDSignOffForm(defForm.DDSignOffTitle, defForm.DDSignOffText)}
                    {this.renderDirSignOffForm(defForm.DirSignOffTitle, defForm.DirSignOffText)}
                    {(showCancelSignOffs === true) ? this.renderCancelSignOffForm() : null}
                </div>
            </div>
        );
    }

    private renderDDSignOffForm(title: string, signoffText: string) {
        return (<SignOffForm orbConfig={this.props.orbConfig} onSignOff={this.props.onSignOff} signoffFor="DD" canSignOffDDSection={this.props.canSignOffDDSection} canSignOffDirSection={this.props.canSignOffDirSection} formId={this.props.formId} form={this.props.form} title={title} signoffText={signoffText} {...this.props} />);
    }

    private renderDirSignOffForm(title: string, signoffText: string) {
        return (<SignOffForm orbConfig={this.props.orbConfig} onSignOff={this.props.onSignOff} signoffFor="Dir" canSignOffDDSection={this.props.canSignOffDDSection} canSignOffDirSection={this.props.canSignOffDirSection} formId={this.props.formId} form={this.props.form} title={title} signoffText={signoffText} {...this.props} />);
    }

    private renderCancelSignOffForm() {
        return (<CancelSignOffForm onCancelSignOff={this.props.onSignOff} formId={this.props.formId} form={this.props.form} title="Cancel Sign-Offs" cancelSignoffText="To cancel all the sign-offs click the following button." {...this.props} />);
    }
}